import React, { useState } from 'react';
import './styles/contactForm.css';
import { FaUser, FaEnvelope, FaPhone, FaBuilding } from 'react-icons/fa';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await addDoc(collection(db, 'mail'), {
        to: ['info@byggerietspartner.dk'],
        message: {
          subject: `Ny henvendelse fra ${formData.name} - ${formData.company}`,
          html: `
            <!DOCTYPE html>
            <html>
              <head>
                <style>
                  body { 
                    font-family: Arial, sans-serif;
                    line-height: 1.6;
                    color: #333333;
                  }
                  .email-container {
                    max-width: 600px;
                    margin: 0 auto;
                    padding: 20px;
                  }
                  .header {
                    background-color: #58863B;
                    color: white;
                    padding: 30px;
                    border-radius: 8px 8px 0 0;
                    text-align: center;
                  }
                  .content {
                    background-color: #ffffff;
                    padding: 30px;
                    border: 1px solid #e0e0e0;
                    border-radius: 0 0 8px 8px;
                  }
                  .info-group {
                    margin-bottom: 20px;
                    padding-bottom: 20px;
                    border-bottom: 1px solid #eee;
                  }
                  .info-label {
                    color: #58863B;
                    font-weight: bold;
                    margin-bottom: 5px;
                  }
                  .info-value {
                    margin: 0;
                  }
                  .message-box {
                    background-color: #f9f9f9;
                    padding: 20px;
                    border-radius: 8px;
                    margin-top: 20px;
                  }
                  .footer {
                    text-align: center;
                    margin-top: 20px;
                    color: #666;
                    font-size: 14px;
                  }
                </style>
              </head>
              <body>
                <div class="email-container">
                  <div class="header">
                    <h1 style="margin:0;">Ny henvendelse fra kontaktformular</h1>
                  </div>
                  <div class="content">
                    <div class="info-group">
                      <div class="info-label">Kontaktperson</div>
                      <p class="info-value">${formData.name}</p>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-label">Virksomhed</div>
                      <p class="info-value">${formData.company}</p>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-label">Kontaktinformation</div>
                      <p class="info-value">
                        Email: ${formData.email}<br>
                        Telefon: ${formData.phone}
                      </p>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-label">Besked</div>
                      <div class="message-box">
                        ${formData.message.replace(/\n/g, '<br>')}
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <p>Denne besked er sendt via kontaktformularen på byggerietspartner.dk</p>
                  </div>
                </div>
              </body>
            </html>
          `,
          text: `
Ny henvendelse fra kontaktformular

KONTAKTPERSON
${formData.name}

VIRKSOMHED
${formData.company}

KONTAKTINFORMATION
Email: ${formData.email}
Telefon: ${formData.phone}

BESKED
${formData.message}

---
Denne besked er sendt via kontaktformularen på byggerietspartner.dk
          `
        }
      });

      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
    } catch (error) {
      console.error('Fejl ved afsendelse:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      // Nulstil status efter 5 sekunder
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-form-container">
      <div className="contact-form-image">
        <img src={require('../images/contactImage.jpg')} alt="Kontakt os" />
      </div>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="contact-form-grid">
          <div className="contact-form-group">
            <div className="contact-input-icon">
              <FaUser />
            </div>
            <input
              type="text"
              name="name"
              placeholder="Dit navn"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="contact-form-group">
            <div className="contact-input-icon">
              <FaEnvelope />
            </div>
            <input
              type="email"
              name="email"
              placeholder="Din e-mail"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="contact-form-group">
            <div className="contact-input-icon">
              <FaPhone />
            </div>
            <input
              type="tel"
              name="phone"
              placeholder="Dit telefonnummer"
              value={formData.phone}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="contact-form-group">
            <div className="contact-input-icon">
              <FaBuilding />
            </div>
            <input
              type="text"
              name="company"
              placeholder="Din virksomhed"
              value={formData.company}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="contact-form-group contact-full-width">
          <textarea
            name="message"
            placeholder="Fortæl os om dit projekt..."
            value={formData.message}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          ></textarea>
        </div>

        <button 
          type="submit" 
          className="contact-submit-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sender...' : 'Send besked'}
        </button>

        {submitStatus === 'success' && (
          <div className="submit-status success">
            Tak for din henvendelse! Vi vender tilbage hurtigst muligt.
          </div>
        )}
        
        {submitStatus === 'error' && (
          <div className="submit-status error">
            Der opstod en fejl. Prøv venligst igen.
          </div>
        )}
      </form>
    </div>
  );
}

export default ContactForm;
